export default {
  color: {
    id: 'pickers_list_color',
    defaultMessage: 'Color',
  },
}
